import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "../../components/reveal/Fade";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  ( {greeting.nickname} • {greeting.yearsOfExperience} ans d'expérience)
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              <SocialMedia theme={theme} />
              <div className="portfolio-buttons">
                <div className="portfolio-repo-btn-div">
                  <Button
                    text="Voir mes réalisations"
                    newTab={true}
                    href="/projects"
                    theme={theme}
                    className="portfolio-repo-btn"
                  />
                </div>
                <div className="portfolio-resume-btn">
                  <Button
                    text="Télécharger mon CV"
                    newTab={true}
                    href={greeting.resumeLink}
                    theme={theme}
                    variant="outline"
                  />
                </div>
            </div>
              {/* <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
            </div> */}
            </div>
          </div>
          <div
            className={
              theme.isDark
                ? "greeting-image-div greeting-image-div--dark"
                : "greeting-image-div"
            }
          >
            {/* En sombre : version détourée, fondue en bas et à droite */}
            <img
              alt="Ilo Nomena"
              src={
                theme.isDark
                  ? require("../../assets/images/ilo-dark.webp")
                  : require("../../assets/images/ilo.png")
              }
            ></img>
            {/* <FeelingProud theme={theme} /> */}
          </div>
        </div>
      </div>
    </Fade>
  );
}
